module.exports = __webpack_public_path__ + "static/media/carousel.b88a48a9.svg";